import { render, staticRenderFns } from "./ProductDetailPanel.vue?vue&type=template&id=56698e4c&scoped=true"
import script from "./ProductDetailPanel.vue?vue&type=script&lang=js"
export * from "./ProductDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailPanel.vue?vue&type=style&index=0&id=56698e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56698e4c",
  null
  
)

export default component.exports